/**
 * Column visibility for v-data-table pages.
 * Expects `headers` (or override via `columnHeadersKey`) with `{ text, value, visible }`.
 */
export default {
  data() {
    return {
      selectedHeaders: [],
    };
  },
  computed: {
    columnHeadersSource() {
      const key = this.columnHeadersKey || "headers";
      return this[key] || [];
    },
    computedHeaders() {
      return this.columnHeadersSource.filter((item) => item.visible === true);
    },
  },
  methods: {
    initColumnVisibility() {
      this.selectedHeaders = this.columnHeadersSource.filter(
        (item) => item.visible === true
      );
    },
    toggleColumnVisibility(selected) {
      const chosen = selected || this.selectedHeaders || [];
      if (!chosen.length) {
        return;
      }

      const values = new Set(chosen.map((header) => header.value));
      this.columnHeadersSource.forEach((header, index) => {
        const keep =
          header.sticky === true || values.has(header.value);
        this.$set(this.columnHeadersSource[index], "visible", keep);
      });

      this.selectedHeaders = this.columnHeadersSource.filter(
        (item) => item.visible === true
      );
    },
  },
};
